import { FC, Fragment, Key } from 'react';
import { ITab } from '@shared/models/tab.model';
import { TabButton } from './TabwithoutSlide.style';
interface Props {
  items: ITab[];
  activeKey: Key;
  setActiveKey: (val: Key) => void;
  themeColor?: string;
}
const TabWithoutSlide: FC<Props> = ({
  items,
  activeKey,
  setActiveKey,
  themeColor
}: Props) => {
  return <Fragment>
            {items?.map(({
      key,
      label
    }) => <TabButton $themeColor={themeColor} key={key} className={key === activeKey && 'active'} onClick={() => setActiveKey(key)}>
                    {label}
                </TabButton>)}
        </Fragment>;
};
export default TabWithoutSlide;